export const iconFontAwesomeSocialLocationPin = (
	<i className="fa-solid fa-location-pin"></i>
);
